window.addEventListener("load", (event) => {
    const tabElements = document.querySelectorAll('.tabs');

    tabElements.forEach(tab => {

        const tabButtons = tab.querySelectorAll('.tab__control-item');
        const tabContents = tab.querySelectorAll('.tab__content');

        function removeActive(ar) {
            ar.forEach(element => {
                element.classList.remove('active');
            });
        }

        tabButtons.forEach(button => {
            button.addEventListener('click', () => {
                if (!button.classList.contains('active')) {
                    let index = [...tabButtons].indexOf(button);
                    let currentContent = [...tabContents][index]

                    removeActive(tabButtons);
                    removeActive(tabContents);

                    button.classList.add('active');
                    currentContent.classList.add('active');

                }
            })
        });

    });

});